export default {"src":"/_next/static/media/american-express-light-noborder.584e64a4.svg","height":24,"width":36};